import React from 'react';
import { motion } from 'framer-motion';

const Cookies: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-purple-800 to-teal-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl font-bold mb-4">Cookies Policy</h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              Understanding how we use cookies to improve your experience
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="prose prose-lg max-w-none"
        >
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">What Are Cookies?</h2>
            <p className="text-gray-600 mb-4">
              Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences, analyzing site usage, and assisting in our marketing efforts.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">How We Use Cookies</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-800">1. Essential Website Operation</h3>
                <p className="text-gray-600">We use cookies to:</p>
                <ul className="list-disc pl-6 text-gray-600 mt-2">
                  <li>Remember your search history and preferences</li>
                  <li>Maintain your session information</li>
                  <li>Enable core website functionality</li>
                  <li>Process search requests efficiently</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800">2. Performance and Analytics</h3>
                <p className="text-gray-600">These cookies help us:</p>
                <ul className="list-disc pl-6 text-gray-600 mt-2">
                  <li>Understand how visitors use our website</li>
                  <li>Track website performance</li>
                  <li>Identify areas for improvement</li>
                  <li>Analyze search patterns and trends</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookie Categories</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-800">Strictly Necessary Cookies</h3>
                <p className="text-gray-600">Required for the website to function properly. These cannot be disabled.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800">Performance Cookies</h3>
                <p className="text-gray-600">Help us understand usage patterns and improve our services.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800">Functional Cookies</h3>
                <p className="text-gray-600">Remember your preferences and personalize your experience.</p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Your Cookie Choices</h2>
            <p className="text-gray-600 mb-4">
              You can control cookies through your browser settings. Most web browsers automatically accept cookies, but you can modify your settings to decline them if you prefer. However, this may prevent you from taking full advantage of our website.
            </p>
            <p className="text-gray-600 mb-4">
              To learn more about managing cookies, visit <a href="https://www.aboutcookies.org" className="text-purple-600 hover:text-purple-800">www.aboutcookies.org</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Updates to This Policy</h2>
            <p className="text-gray-600 mb-4">
              We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date. Please check back periodically to stay informed about our use of cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-600">
              If you have any questions about our use of cookies, please contact us at{' '}
              <a href="mailto:contact@pincodeindia.tag360.in" className="text-purple-600 hover:text-purple-800">
                contact@pincodeindia.tag360.in
              </a>
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Cookies;
